<app-modal
  [title]="'Edit client data' | trans:'customers/customer-details-modal/header/title'"
  [compact]="false"
  maxWidth="1600px"
  [showBackButton]="true"
  (backButtonClick)="close()"
>
  <ng-template>
    @if (isLoading()) {
      <div class="d-flex justify-content-center full-height align-items-center">
        <app-loader size="lg" />
      </div>
    } @else {
      @if (customer) {
        <app-toggle-tabs-menu
          [options]="toggleTabsMenuOptions"
          [(selectedIndex)]="selectedToggleTabsMenuOptionsIndex"
        />

        <div class="m-t-24 d-block">
          <app-edit-customer-details-form
            [data]="customer"
            [hidden]="selectedToggleTabsMenuOptionsIndex !== 0"
            (formFinished)="formFinished.emit($event)"
            #formComponent
          />
          @if (selectedToggleTabsMenuOptionsIndex !== 0) {
            @if (selectedToggleTabsMenuOptionsIndex === 1) {
              <app-actions-history-table [customer]="customer" />
            } @else if (selectedToggleTabsMenuOptionsIndex === 2) {
              <app-cards-table [customer]="customer" />
            } @else if (selectedToggleTabsMenuOptionsIndex === 3) {
              <app-transaction-positions-table [customer]="customer" />
            } @else if (selectedToggleTabsMenuOptionsIndex === 4) {
              <app-logs-table [customer]="customer" />
            } @else if (selectedToggleTabsMenuOptionsIndex === 5) {
              <app-newsletter-table [customer]="customer" />
            }
          }
        </div>
      }
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
        [disabled]="isFormSubmitting"
      >
        {{ 'Cancel'| trans:'customers/customer-details-modal/cancel.Button' }}
      </button>

      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="selectedToggleTabsMenuOptionsIndex !== 0 || isFormSubmitting"
        (click)="submitForm()"
      >
        {{ 'Save' | trans:'customers/customer-details-modal/save.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
